import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { CoachingDashboardStateModel } from 'src/core/models/coaching/coaching-dashboard.state-model';
import { CoachingDashboardActiveTabChange } from 'src/core/actions/coaching/coaching-dashboard.actions';
import { UserStateSettingsService } from 'src/core/services/state/user-state-settings.service';
import { GenericState } from '../generic/generic.state';

const name = 'CoachingDashboardState';

@State<CoachingDashboardStateModel>({
  name: name,
  defaults: {
    activeTab: 1,
  },
})
@Injectable()
export class CoachingDashboardState extends GenericState<CoachingDashboardState> {
  @Selector()
  static getActiveTab(state: CoachingDashboardStateModel): number {
    return state.activeTab;
  }

  @Action(CoachingDashboardActiveTabChange)
  changeActiveTab(
    ctx: StateContext<CoachingDashboardStateModel>,
    action: CoachingDashboardActiveTabChange,
  ) {
    const currentState = ctx.getState();
    currentState.activeTab = action.activeTab;
    this.userSettingsService.patchState(ctx, currentState, name);
  }

  constructor(userSettingsService: UserStateSettingsService) {
    super(userSettingsService);
    this.name = name;

    this.userSettingsService.register(this.name, this);
  }
}
